import React from 'react';
import { SpzPage } from '@shared/components/spz-page';

const SpzPageTemplate = ({ pageContext }: { pageContext: any }) => {
  return <SpzPage pageContext={pageContext} />;
};

export default SpzPageTemplate;
